export const SearchContext = {
    Investors: 'Investors',
    Startups: 'Startups',
    Personal: 'Personal',
    All: 'All'
}
